/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import { ORG_SETTINGS_COLORS, ORG_SETTINGS_SPACING } from './OrgSettingsStyleLib';

export type CreateApiKeyModalStyles = {
  form: SerializedStyles;
  fullWidthField: SerializedStyles;
  secret: SerializedStyles;
  copyActions: SerializedStyles;
};

export const DEFAULT_CREATE_API_KEY_MODAL_STYLES: CreateApiKeyModalStyles = {
  form: css`
    label: CREATE_API_KEY_MODAL_FORM;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${ORG_SETTINGS_SPACING.gutterX}px;
  `,
  fullWidthField: css`
    label: CREATE_API_KEY_MODAL_FULL_WIDTH_FIELD;
    grid-column: 1 / -1;
  `,
  secret: css`
    label: CREATE_API_KEY_MODAL_SECRET;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
    border: 1px solid ${ORG_SETTINGS_COLORS.border};
    padding: ${ORG_SETTINGS_SPACING.standardPadding}px;
  `,
  copyActions: css`
    label: CREATE_API_KEY_MODAL_COPY_ACTIONS;
    display: flex;
    align-items: center;
    gap: ${ORG_SETTINGS_SPACING.gutterX}px;
    margin-top: ${ORG_SETTINGS_SPACING.standardPadding}px;
  `,
};
